import { Component, signal, effect, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IconComponent } from './ui/icon.component';
import { ModalService } from '../services/modal.service';

declare var hbspt: any;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, IconComponent, RouterModule],
  template: `
    <header class="fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b"
            [class.bg-[#111111]/95]="isScrolled()"
            [class.backdrop-blur-md]="isScrolled()"
            [class.border-white/10]="isScrolled()"
            [class.py-3]="isScrolled()"
            [class.bg-[#111111]]="!isScrolled()"
            [class.border-transparent]="!isScrolled()"
            [class.py-5]="!isScrolled()">
      <div class="container mx-auto px-4 md:px-6 flex items-center justify-between">
        
        <!-- Logo Image -->
        <div class="flex items-center cursor-pointer" (click)="scrollTo('hero')">
          <img src="/images/logo-branca.svg" 
               alt="beetrack Logo" 
               width="120"
               height="40"
               class="h-8 md:h-10 w-auto object-contain">
        </div>

        <!-- Desktop Nav -->
        <nav class="hidden md:flex items-center gap-8">
          <button (click)="scrollTo('how-it-works')" class="text-sm font-medium text-gray-300 hover:text-white transition-colors">Como Funciona</button>
          <button (click)="scrollTo('risk')" class="text-sm font-medium text-gray-300 hover:text-white transition-colors">A Legislação</button>
          <button (click)="scrollTo('news')" class="text-sm font-medium text-gray-300 hover:text-white transition-colors">Notícias</button>
          <button (click)="scrollTo('segments')" class="text-sm font-medium text-gray-300 hover:text-white transition-colors">Segmentos</button>
          <button (click)="scrollTo('faq')" class="text-sm font-medium text-gray-300 hover:text-white transition-colors">Dúvidas</button>
          <a routerLink="/blog" class="text-sm font-medium text-gray-300 hover:text-[#FF5500] transition-colors">Blog</a>
        </nav>

        <!-- CTAs (hidden on V2) -->
        @if (!isV2) {
          <div class="hidden md:flex items-center gap-4">
             <a routerLink="/parceiros" class="text-sm font-medium text-[#FF5500] hover:text-[#FF5500]/80 transition-colors">
              Seja um Revendedor
            </a>
            <button (click)="openModal()" class="bg-[#FF5500] hover:bg-[#E04800] text-[#111111] px-5 py-2.5 rounded-lg text-sm font-bold transition-all shadow-lg hover:shadow-[#FF5500]/20">
              Falar com Especialista
            </button>
          </div>
        }
        @if (isV2) {
          <div class="hidden md:flex items-center gap-4">
            <button (click)="openModal()" class="bg-[#FF5500] hover:bg-[#E04800] text-[#111111] px-5 py-2.5 rounded-lg text-sm font-bold transition-all shadow-lg hover:shadow-[#FF5500]/20">
              Quero meu Diagnóstico Gratuito →
            </button>
          </div>
        }

        <!-- Mobile Menu Button -->
        <button class="md:hidden text-white" (click)="toggleMobileMenu()" aria-label="Abrir menu de navegação" [attr.aria-expanded]="mobileMenuOpen()">
          <app-icon [name]="mobileMenuOpen() ? 'x' : 'menu'" [size]="28"></app-icon>
        </button>
      </div>

      <!-- Mobile Menu Dropdown -->
      @if (mobileMenuOpen()) {
        <div class="md:hidden absolute top-full left-0 right-0 bg-[#111111] border-b border-white/10 p-4 flex flex-col gap-4 shadow-xl">
          <button (click)="scrollTo('how-it-works')" class="text-left text-gray-300 py-2">Como Funciona</button>
          <button (click)="scrollTo('risk')" class="text-left text-gray-300 py-2">A Legislação</button>
          <button (click)="scrollTo('news')" class="text-left text-gray-300 py-2">Notícias</button>
          <button (click)="scrollTo('segments')" class="text-left text-gray-300 py-2">Segmentos</button>
          <a routerLink="/blog" (click)="mobileMenuOpen.set(false)" class="text-left text-gray-300 py-2 hover:text-[#FF5500] transition-colors">Blog</a>
          @if (!isV2) {
            <a routerLink="/parceiros" (click)="mobileMenuOpen.set(false)" class="text-left text-[#FF5500] py-2">Seja um Revendedor</a>
            <button (click)="openModal()" class="bg-[#FF5500] text-[#111111] w-full py-3 rounded-lg font-bold text-center">
              Falar com Especialista
            </button>
          }
          @if (isV2) {
            <button (click)="openModal()" class="bg-[#FF5500] text-[#111111] w-full py-3 rounded-lg font-bold text-center">
              Quero meu Diagnóstico Gratuito →
            </button>
          }
        </div>
      }
    </header>

    <!-- Reseller Modal -->
    @if (resellerModalOpen()) {
      <div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in">
        <div class="bg-white border border-white/10 rounded-xl shadow-2xl max-w-lg w-full p-6 relative overflow-hidden flex flex-col max-h-[95vh] sm:max-h-[90vh]">
          <button (click)="toggleResellerModal()" class="absolute top-4 right-4 text-gray-400 hover:text-gray-200 z-50">
            <app-icon name="x" [size]="24"></app-icon>
          </button>
          
          <div class="overflow-y-auto w-full min-h-[400px]">
            <div class="mb-6 text-center">
               <div class="w-12 h-12 bg-[#FF5500]/10 rounded-full flex items-center justify-center mx-auto mb-4 text-[#FF5500]">
                  <app-icon name="activity" [size]="24"></app-icon>
               </div>
               <h3 class="text-2xl font-bold text-black mb-2">Transforme seu relacionamento em receita recorrente</h3>
               <p class="text-gray-400 text-sm">Ofereça aos seus clientes uma solução que evita ações trabalhistas e gera valor imediato.</p>
            </div>

            <div id="hubspot-reseller-container" class="hubspot-form-wrapper"></div>
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    @keyframes fade-in {
      from { opacity: 0; transform: scale(0.95); }
      to { opacity: 1; transform: scale(1); }
    }
    .animate-fade-in {
      animation: fade-in 0.2s ease-out forwards;
    }
  `]
})
export class HeaderComponent {
  isScrolled = signal(false);
  mobileMenuOpen = signal(false);
  resellerModalOpen = signal(false);
  modalService = inject(ModalService);
  router = inject(Router);

  get isV2() {
    return this.router.url.includes('/v2');
  }

  get formId() {
    return this.isV2
      ? '8fcc44f6-f31d-4746-9e31-23e53219ff52'
      : '73c9f1ef-d8f9-4abb-b1cf-7013aadc9950';
  }

  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', () => {
        this.isScrolled.set(window.scrollY > 20);
      });
    }

    effect(() => {
      if (this.resellerModalOpen()) {
        setTimeout(() => this.loadHubSpotForm(), 100);
      }
    });
  }

  private loadHubSpotForm() {
    // We add the script tag dynamically if it doesn't exist
    if (!document.querySelector('script[src="//js.hsforms.net/forms/embed/v2.js"]')) {
      const script = document.createElement('script');
      script.src = '//js.hsforms.net/forms/embed/v2.js';
      script.defer = true;
      script.onload = () => this.initHubSpotForm();
      document.body.appendChild(script);
    } else {
      this.initHubSpotForm();
    }
  }

  private initHubSpotForm() {
    if (typeof hbspt !== 'undefined') {
      const container = document.getElementById('hubspot-reseller-container');
      if (container && !container.hasChildNodes()) {
        hbspt.forms.create({
          portalId: "51135977",
          formId: this.formId,
          region: "na1",
          target: '#hubspot-reseller-container'
        });
      }
    } else {
      setTimeout(() => this.initHubSpotForm(), 500);
    }
  }

  scrollTo(id: string) {
    this.mobileMenuOpen.set(false);

    const isHome = this.router.url === '/' || this.router.url === '' || this.router.url.startsWith('/v3');

    if (isHome) {
      // Already on home — just scroll
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Navigate to home first, then scroll after render
      this.router.navigate(['/']).then(() => {
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 350);
      });
    }
  }

  toggleMobileMenu() {
    this.mobileMenuOpen.update(v => !v);
  }

  toggleResellerModal() {
    if (this.router.url.includes('/v2')) {
      this.mobileMenuOpen.set(false);
      this.router.navigate(['/v2/obrigado']);
    } else {
      this.resellerModalOpen.update(v => !v);
    }
  }

  openModal() {
    this.mobileMenuOpen.set(false);
    if (this.router.url.includes('/v2')) {
      this.router.navigate(['/v2/obrigado']);
    } else {
      this.modalService.open();
    }
  }
}